import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bad6c6e2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bad6c6e2&prod&lang=stylus&module=modal"
import style1 from "./index.vue?vue&type=style&index=1&id=bad6c6e2&prod&scoped=true&lang=css"




function injectStyles (context) {
  
  this["modal"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bad6c6e2",
  null
  
)

export default component.exports